(() => {
  function initialize() {
    const checkbox = document.getElementById("kupuje-na-firme");
    const block = document.getElementById("nip-block");
    const nipInput = document.getElementById("cart-nip");
    const nipError = document.getElementById("nip-error");
    const checkoutBtn = document.getElementById("checkout");
    const feedback = document.getElementById("nip-feedback");
    const companyNameInput = document.getElementById("cart-company-name");

    if (!checkbox || !block || !nipInput) return;

    // 'empty' — field is blank (checkout allowed)
    // 'invalid' — user typed something or API returned nothing (checkout blocked)
    // 'valid' — API confirmed the NIP (checkout allowed)
    let nipState = nipInput.value.trim() ? "invalid" : "empty";
    let validateSeq = 0;

    function setFeedback(text, isError = false) {
      feedback.textContent = text;
      feedback.classList.toggle("error", isError);
    }

    function clearFeedback() {
      feedback.textContent = "";
      feedback.classList.remove("error");
    }

    function updateCheckout() {
      if (!checkoutBtn) return;
      checkoutBtn.disabled = checkbox.checked && nipState === "invalid";
    }

    function toggle() {
      if (checkbox.checked) {
        block.removeAttribute("hidden");
      } else {
        block.setAttribute("hidden", "");
        clearFeedback();
        nipInput.value = "";
        nipState = "empty";
        if (nipError) nipError.setAttribute("hidden", "");
        if (companyNameInput) companyNameInput.value = "";
        // Clear NIP from Shopify cart so it doesn't persist to the next order
        updateCartAttribute("NIP", "");
        updateCartAttribute("company_name", "");
      }
      updateCheckout();
    }

    async function validateNIP(nip) {
      const clean = nip.replace(/[-\s]/g, "");
      if (clean.length !== 10) return null;

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const today = new Date().toISOString().slice(0, 10);
        const res = await fetch(
          `https://wl-api.mf.gov.pl/api/search/nip/${clean}?date=${today}`,
          { signal: controller.signal },
        );
        if (!res.ok) return null;
        const data = await res.json();
        return data?.result?.subject || null;
      } catch {
        return null;
      } finally {
        clearTimeout(timeout);
      }
    }

    // Saves a cart attribute via Shopify AJAX API so it reaches order.note_attributes
    // regardless of how the checkout button is triggered (JS navigation, etc.)
    async function updateCartAttribute(key, value) {
      try {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: { [key]: value } }),
        });
      } catch {
        // Non-critical — form submit is the fallback
      }
    }

    // Digits-only, max 10 chars — enforced on every keystroke
    nipInput.addEventListener("input", function () {
      const digits = this.value.replace(/\D/g, "").slice(0, 10);
      if (this.value !== digits) this.value = digits;

      nipState = digits.length === 0 ? "empty" : "invalid";
      clearFeedback();
      if (nipError) nipError.setAttribute("hidden", "");
      if (companyNameInput) companyNameInput.value = "";
      updateCheckout();
    });

    nipInput.addEventListener("blur", async function () {
      const nip = this.value.trim();

      if (nip.length === 0) {
        nipState = "empty";
        clearFeedback();
        if (companyNameInput) companyNameInput.value = "";
        // Clear the saved attribute in the cart too
        await updateCartAttribute("NIP", "");
        await updateCartAttribute("company_name", "");
        updateCheckout();
        return;
      }

      if (nip.length !== 10) {
        nipState = "invalid";
        setFeedback("❌ NIP musi mieć dokładnie 10 cyfr", true);
        updateCheckout();
        return;
      }

      const thisReq = ++validateSeq;
      setFeedback("Sprawdzanie...");

      const company = await validateNIP(nip);

      // Discard stale response if user triggered another validation
      if (thisReq !== validateSeq) return;

      if (company) {
        nipState = "valid";
        setFeedback("✅ " + company.name);
        if (nipError) nipError.setAttribute("hidden", "");
        if (companyNameInput) companyNameInput.value = company.name;
        // Persist NIP + verified company name to Shopify cart so both survive to order.note_attributes
        await updateCartAttribute("NIP", nip);
        await updateCartAttribute("company_name", company.name);
      } else {
        nipState = "invalid";
        setFeedback("❌ Nie znaleziono firmy o podanym NIP", true);
        if (companyNameInput) companyNameInput.value = "";
        await updateCartAttribute("company_name", "");
      }
      updateCheckout();
    });

    toggle();
    checkbox.addEventListener("change", toggle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }
})();
